export default {
  methods: {
    getCookie: function (cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    },
    setCookie: function (cname, cvalue, exdays, samesite = 'Lax') {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";" + "SameSite=" + samesite + ";Secure;path=/";
    },
    eraseCookie: function (name) {
      document.cookie =
        name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    },
    checkCookie: function (cookieName) {
      var cookieValue = this.getCookie(cookieName);
      if (cookieValue != null) {
        return cookieValue;
      } else {
        return false;
      }
    },
    checkCookieValue: function (cookieName) {
      var cookieValue = this.getCookie(cookieName);
      if (cookieValue != null) {
        return cookieValue;
      }
    },
  },
};
